






































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

// --- Services ---
import AppService from '@/services/app';
import AuthService from '@/services/auth';

@Component
export default class ResultsGenerator extends Vue {

  async emailReport() {
    try {
      const response = await AuthService.emailReport();

      if (response && response.data) {
        if (response.data.result && response.data.result === 'false') {
          AppService.errorHandler(response.data.message);
        } else {
          AppService.successHandler(response.data.message);
        }
      } else {
        // response is undefined or has no data field - SHOULD NEVER HAPPEN!
        throw new Error('response: ' + JSON.stringify(response));
      }

    } catch (error) {

      if (error.response) {
        AppService.errorHandler(error.response.statusText);
      } else {
        await AuthService.logSupportDebug('ResultsGenerator.vue - 69 - emailReport - ' + error);
        AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
      }

    }
  }

  async beforeMount() {
    try {
      const response = await AuthService.createReport();

      if (response && response.data) {
        if (response.data.result === 'false') {
          AppService.errorHandler(response.data.message);
        } else {

          // now trigger the email to the User in the background
          await this.emailReport();
          this.$router.push( { name: 'Results Complete' } );
        }
      } else {
        // response is undefined or has no data field - SHOULD NEVER HAPPEN!
        throw new Error('response: ' + JSON.stringify(response));
      }

    } catch (error) {
      if (error.response) {
        AppService.errorHandler(error.response.statusText);
      } else {
        await AuthService.logSupportDebug('ResultsGenerator.vue - 98 - beforeMount - ' + error);
        AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
      }

    }
  }
}
